import rpcHeaders from '#/store/headers';
import { queryProjectClient, modifyClient, deletionClient } from '#/clients';

export const getters = {
  urls: (state) => state.downloadUrls,
};

export const mutations = {
  addDownloadUrl: (state, url) => {
    state.downloadUrls.push(url);
  },
  resetDownloadUrl: (state) => {
    state.downloadUrls = [];
  },
};

export const actions = {
  updateDownloadList: async ({ commit }, url) => {
    const newUrl = url;
    newUrl.status = 'pending';
    commit('addDownloadUrl', newUrl);
  },
  loadList: async ({ rootState }, request) => {
    console.log('loading entity list');
    try {
      const headers = await rpcHeaders(rootState);
      return new Promise((resolve, reject) => {
        queryProjectClient.listEntities(request, headers, (err, response) => {
          if (err != null) {
            console.log('received err from listEntities ', err);
            return reject(err);
          }
          return resolve(response.toObject());
        });
      });
    } catch (error) {
      console.log('caught error loading entity page:', error);
      return Promise.reject(error);
    }
  },
  loadDetails: async ({ rootState }, request) => {
    console.log('loading entity details', request);
    try {
      const headers = await rpcHeaders(rootState);
      return new Promise((resolve, reject) => {
        queryProjectClient.getEntities(request, headers, (err, response) => {
          if (err != null) {
            console.log('received err from getEntities ', err);
            return reject(err);
          }
          return resolve(response);
        });
      });
    } catch (error) {
      console.log('caught error loading entity page:', error);
      return Promise.reject(error);
    }
  },
  updateTags: async ({ rootState }, request) => {
    console.log('updating tags for entity', request);
    try {
      const headers = await rpcHeaders(rootState);
      return new Promise((resolve, reject) => {
        modifyClient.updateEntityTags(request, headers, (err, response) => {
          if (err != null) {
            console.log('received err from updateEntityTags ', err);
            return reject(err);
          }
          const r = response.toObject();
          return resolve(r);
        });
      });
    } catch (error) {
      console.log('caught error updating job tags:', error);
      return Promise.reject(error);
    }
  },
  delete: async ({ rootState }, request) => {
    console.log('deleting entity', request);
    try {
      const headers = await rpcHeaders(rootState);
      return new Promise((resolve, reject) => {
        deletionClient.deleteEntities(request, headers, (err, response) => {
          if (err != null) {
            console.log('received err from entity deletion', err);
            return reject(err);
          }
          const r = response.toObject();
          return resolve(r);
        });
      });
    } catch (error) {
      console.log('caught error in entity deletion:', error);
      return Promise.reject(error);
    }
  },
};

export const state = {
  entities: {},
  downloadUrls: [],
};

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state,
};
